import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="site-footer">

      <div className="footer-container">

        <div className="footer-brand">
          <div className="footer-logo">
            Hopeful Horizons NY LLC
          </div>

          <p className="footer-tagline">
            Helping families connect with qualified DSP professionals
            across New York State.
          </p>
        </div>


        <div className="footer-links">

          <div className="footer-column">
            <div className="footer-title">Company</div>

            <Link to="/about">About Hopeful Horizons NY</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/advertise">Advertise with us</Link>
            <Link to="/notary">Notary Services</Link>
            <Link to="/jobs">Jobs</Link>

          </div>


          <div className="footer-column">
            <div className="footer-title">Legal</div>

            <Link to="/terms">Terms of Use</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/cookies">Cookies</Link>
            <Link to="/donotsell">Do not share or sell my info</Link>

          </div>


          <div className="footer-column">
            <div className="footer-title">Support</div>

            <Link to="/faq">Help & FAQs</Link>
            <Link to="/accessibility">Accessibility Help</Link>

          </div>

        </div>

      </div>


      <div className="footer-bottom">

        <div>
          © {new Date().getFullYear()} Hopeful Horizons NY LLC
        </div>

        <div className="footer-small-links">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/contact">Contact</Link>
        </div>

      </div>

    </footer>
  );
}